import { SelectOption } from 'src/UIKit';

export const DYNAMIC_GROUP_GROUP_ID_FIELD = 'groupId';

export const emptyValueOperators = ['is_null', 'is_not_null'];

export const ruleOperatorOptions: SelectOption[] = [
  { title: "equal", value: "=" },
  { title: "not equal", value: "!=" },
  { title: "≤", value: "<=" },
  { title: "<", value: "<" },
  { title: "≥", value: ">=" },
  { title: ">", value: ">" },
  { title: "is empty", value: "is_null" },
  { title: "is not empty", value: "is_not_null" },
];

export const dateRuleOperatorOptions: SelectOption[] = [
  { title: 'equal', value: '=' },
  { title: 'not equal', value: '!=' },
  { title: 'before', value: '<' },
  { title: 'after', value: '>' },
  { title: 'is empty', value: 'is_null' },
  { title: 'is not empty', value: 'is_not_null' },
];

export const groupIdRuleOperatorOptions: SelectOption[] = [
  { title: 'is in', value: '=' },
  { title: 'is not in', value: '!=' },
];

export function hasEmptyRuleValue(operator?: string): boolean {
  return emptyValueOperators.includes(operator || '');
}

export const normalizeRuleValues = (values: readonly string[]): string[] =>
  values.map(value => value.trim()).filter(Boolean);
